import { useTranslation } from 'react-i18next';
import Button from 'components/Button/Button';
import { BUTTON_VARIANT } from 'constants/interfaces';

import type { ICreateSurveyActionButtons } from '../interfaces/ICreateSurveyActionButtons';

import styles from '../scss/CreateSurveyActionButtons.module.scss';

function CreateSurveyActionButtons({
  onCancel,
  onSaveAsDraft,
  onMarkAsDone,
  isLoading = false,
  isSavingDraft = false,
  isSavingDone = false,
}: ICreateSurveyActionButtons) {
  const { t } = useTranslation();

  return (
    <div className={styles.actions}>
      <div className={styles.leftActions}>
        <Button
          variant={BUTTON_VARIANT.cancel}
          title={t('common.cancel')}
          onClick={onCancel}
          disabled={isLoading || isSavingDraft || isSavingDone}
        />
      </div>
      <div className={styles.rightActions}>
        <Button
          variant={BUTTON_VARIANT.cancel}
          title={t('common.saveAsDraft')}
          isLoading={isSavingDraft}
          onClick={onSaveAsDraft}
          disabled={isLoading || isSavingDone}
        />
        <Button
          title={t('common.markAsDone')}
          isLoading={isSavingDone}
          onClick={onMarkAsDone}
          disabled={isLoading || isSavingDraft}
        />
      </div>
    </div>
  );
}

export default CreateSurveyActionButtons;
